import React from 'react';
import { ExternalLink } from 'lucide-react';

const fmt = (ts) => {
  if (!ts) return 'Unknown';
  const d = new Date(ts);
  return Number.isNaN(d.getTime()) ? ts : d.toLocaleString();
};

export const safeUrl = (url) => (typeof url === 'string' && url.startsWith('https://') ? url : null);

export const SourceMeta = ({ source, asOfLabel = 'Price as of', testId }) => {
  if (!source) return null;
  const url = safeUrl(source.sourceUrl || source.url);
  return (
    <div className="text-xs text-gray-500 space-y-0.5 border-t border-white/5 pt-3 mt-3" data-testid={testId}>
      <p>Provider: <span className="text-gray-300">{source.provider}</span>{source.priceType ? ` · ${source.priceType}` : ''}</p>
      <p>{asOfLabel}: <span className="text-gray-300">{source.asOf}</span>{source.timezone ? ` (${source.timezone})` : ''}</p>
      {source.retrievedAt && <p>Retrieved: <span className="text-gray-300">{fmt(source.retrievedAt)}</span></p>}
      {url && (
        <a href={url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-[#00E676] hover:underline break-all">
          Source <ExternalLink className="w-3 h-3" />
        </a>
      )}
    </div>
  );
};
